import { useEffect, useState } from 'react';
import api from '../../api/axios';
import MasterEditModal from '../../components/MasterEditModal';
import { DEFAULT_BODY_RESULT_OPTIONS, DEFAULT_GENERIC_RESULT_OPTIONS } from '../../utils/resultOptions';

const types = [
  'engine_size','warranty_status','transmission','keys_count','fuel_type','cylinders','engine_condition',
  'drive_type','gear_type','body_shape','seat_type','seats_count','exterior_color','interior_color',
  'inspection_result_generic','inspection_result_body',
];

export default function Lookups() {
  const [type, setType] = useState('engine_size');
  const [rows, setRows] = useState([]);
  const [value, setValue] = useState('');
  const [label, setLabel] = useState('');
  const [color, setColor] = useState('');
  const [description, setDescription] = useState('');
  const [sortOrder, setSortOrder] = useState(1);
  const [editRow, setEditRow] = useState(null);
  const [editForm, setEditForm] = useState({
    type: '',
    value: '',
    label: '',
    color: '',
    description: '',
    sort_order: 1,
  });
  const [saving, setSaving] = useState(false);

  const isResultType = type === 'inspection_result_generic' || type === 'inspection_result_body';
  const resultPresets = isResultType
    ? (type === 'inspection_result_body' ? DEFAULT_BODY_RESULT_OPTIONS : DEFAULT_GENERIC_RESULT_OPTIONS)
    : [];

  const load = () => api.get(`/lookups/by-type/${type}`).then((r) => setRows(r.data));
  useEffect(() => {
    api.get(`/lookups/by-type/${type}`).then((r) => setRows(r.data));
  }, [type]);

  const add = async () => {
    if (!value) return;
    await api.post('/lookups', {
      type,
      value,
      label: label || null,
      color: color || null,
      description: description || null,
      sort_order: Number(sortOrder) || 0,
    });
    setValue('');
    setLabel('');
    setColor('');
    setDescription('');
    setSortOrder(1);
    load();
  };

  const openEdit = (row) => {
    setEditRow(row);
    setEditForm({
      type: row.type || type,
      value: row.value || '',
      label: row.label || '',
      color: row.color || '',
      description: row.description || '',
      sort_order: row.sort_order ?? 0,
    });
  };

  const update = async () => {
    if (!editForm.type || !editForm.value.trim() || !editRow) return;
    setSaving(true);
    try {
      await api.put(`/lookups/${editRow.id}`, {
        type: editForm.type,
        value: editForm.value,
        label: editForm.label || null,
        color: editForm.color || null,
        description: editForm.description || null,
        sort_order: Number(editForm.sort_order) || 0,
      });
      setEditRow(null);
      load();
    } finally {
      setSaving(false);
    }
  };

  const remove = async (row) => {
    if (!window.confirm('تأكيد الحذف؟')) return;
    await api.delete(`/lookups/${row.id}`);
    load();
  };

  return (
    <div>
      <div className="grid md:grid-cols-6 gap-2 mb-3">
        <select value={type} onChange={(e) => setType(e.target.value)} className="rounded-lg border p-2">
          {types.map((t) => <option key={t} value={t}>{t}</option>)}
        </select>
        <div className="grid gap-2">
          {isResultType && (
            <select value="" onChange={(e) => setValue(e.target.value)} className="rounded-lg border p-2">
              <option value="">Preset key</option>
              {resultPresets.map((option) => <option key={option.value} value={option.value}>{option.value} - {option.label}</option>)}
            </select>
          )}
          <input value={value} onChange={(e) => setValue(e.target.value)} className="rounded-lg border p-2" placeholder={isResultType ? 'custom_key' : 'القيمة'} dir={isResultType ? 'ltr' : undefined} />
        </div>
        <input value={label} onChange={(e) => setLabel(e.target.value)} className="rounded-lg border p-2" placeholder="الاسم الظاهر" />
        <input value={color} onChange={(e) => setColor(e.target.value)} className="rounded-lg border p-2" placeholder="#22c55e" />
        <input value={description} onChange={(e) => setDescription(e.target.value)} className="rounded-lg border p-2" placeholder="وصف مختصر" />
        <input type="number" value={sortOrder} onChange={(e) => setSortOrder(e.target.value)} className="rounded-lg border p-2" placeholder="الترتيب" />
        <button onClick={add} className="rounded-lg bg-primary px-3 py-2 text-white">إضافة</button>
      </div>

      {/* ...تم حذف الرسالة التوضيحية بناءً على طلب العميل... */}

      <div
        dir="ltr"
        className="w-full overflow-x-auto rounded-lg border overscroll-x-contain [-webkit-overflow-scrolling:touch]"
      >
        <table dir="rtl" className="min-w-[820px] w-full text-sm">
          <thead className="bg-slate-100"><tr><th className="p-2 text-right">المفتاح</th><th className="p-2 text-right">الاسم الظاهر</th><th className="p-2 text-right">اللون</th><th className="p-2 text-right">الوصف</th><th className="p-2 text-right">الترتيب</th><th className="p-2">إجراءات</th></tr></thead>
          <tbody>{rows.map((r) => <tr key={r.id} className="border-t"><td className="p-2 font-mono text-xs">{r.value}</td><td className="p-2">{r.label || r.value}</td><td className="p-2"><div className="inline-flex items-center gap-2 whitespace-nowrap"><span className="h-4 w-4 rounded-full border" style={{ backgroundColor: r.color || 'transparent' }} />{r.color || '-'}</div></td><td className="p-2">{r.description || '-'}</td><td className="p-2">{r.sort_order}</td><td className="p-2"><div className="flex gap-2 justify-center whitespace-nowrap"><button onClick={() => openEdit(r)} className="px-2 py-1 border rounded">تعديل</button><button onClick={() => remove(r)} className="px-2 py-1 border rounded text-red-600">حذف</button></div></td></tr>)}</tbody>
        </table>
      </div>

      <MasterEditModal
        open={Boolean(editRow)}
        title="تعديل القائمة الثابتة"
        subtitle="عدّل كل بيانات القيمة ثم اضغط حفظ."
        fields={[
          {
            name: 'type',
            label: 'نوع القائمة',
            type: 'select',
            required: true,
            options: types.map((item) => ({ value: item, label: item })),
          },
          { name: 'value', label: 'القيمة', required: true },
          { name: 'label', label: 'الاسم الظاهر' },
          { name: 'color', label: 'اللون HEX', placeholder: '#22c55e' },
          { name: 'description', label: 'الوصف', type: 'textarea', fullWidth: true },
          { name: 'sort_order', label: 'الترتيب', type: 'number' },
        ]}
        values={editForm}
        onChange={(key, value) => setEditForm((current) => ({ ...current, [key]: value }))}
        onClose={() => setEditRow(null)}
        onSubmit={update}
        saving={saving}
      />
    </div>
  );
}
